<div dropdown #dropdown="bs-dropdown" [insideClick]="true">
    <!-- Dropdown Toggle -->

    <div class="btn-group d-flex flex-row flex-nowrap" >

      <button
          [id]="id() + 'button-basic'" dropdownToggle 
          class="text-start btn btn-link p-3 font-5 primary-text w-100"                     
          [ngClass]="{
            'dropdown-toggle': !disabled(),
            'disabled': disabled()
          }"
          [disabled]="disabled()"
          aria-expanded="false"
          [attr.aria-disabled]="disabled()"
          [attr.aria-controls]="id() + 'dropdown-basic'">
          <ng-content select="[dropdown-toggle]" ngProjectAs="[dropdown-toggle]"></ng-content>
      </button>
      
    </div>

    <!-- Dropdown Menu -->
    @if (!disabled()) {
      <div [id]="id() + 'dropdown-basic'" 
          [attr.aria-labelledby]="id() + 'button-basic'"
          class="dropdown-menu dropdown-content m-0 p-0" *dropdownMenu>

          <ng-content 
              select="[dropdown-content]" ngProjectAs="[dropdown-content]">
          </ng-content>
      </div>
    }
</div>

